import type * as React from 'react';
import type { Props } from './interface';
import Button from '../index';
import './styles.less';

const SimpleButton: React.FunctionComponent<Props> = ({ id, icon, disabled, onClick, className }) => {
  const variant = 'neutral';
  const type = 'default';
  const buttonClassName = ['simple-icon', className].filter(Boolean).join(' ');

  return <Button id={id} variant={variant} type={type} icon={icon} className={buttonClassName} onClick={onClick} disabled={disabled} />;
};

export default SimpleButton;
